import axios from "axios";
import { getToken } from "./setToken.js";
import { Message } from 'element-ui'

const service = axios.create({
    baseURL: '/api',
    headers: {
        'Content-Type': 'application/json;'
    },
    timeout: 5000
})

// 添加请求拦截器
service.interceptors.request.use((config) => {
    // 在请求之前需要做的事（例如获取并设置token）
    config.headers['token'] = getToken('token')
    return config
}, (error) => {
    return Promise.reject(error)
})

// 添加响应拦截器
service.interceptors.response.use((response) => {
    // 对响应数据的操作
    let { code, tip } = response.data
    if(code !== 200){
        Message({message: tip || 'error', type: 'warning'})
    }
    return response
}, (error) => {
    return Promise.reject(error)
})


// // 设置请求次数，请求的间隙
// service.defaults.retry = 4;
// service.defaults.retryDelay = 1000;
 
// // request interceptor
// service.interceptors.request.use(
//   config => {
//     // do something before request is sent
//     return config
//   },
//   error => {
//     // do something with request error
//     // console.log(error) // for debug
//     return Promise.reject(error)
//   }
// )
 
// // response interceptor
// service.interceptors.response.use(
//   response => {
//     const res = response.data
//     return res
//   },
//   error => {
//     if (error.response) {
//       // console.log('err' + error) // for debug
//       switch (error.response.status) {
//         case 401:
//           // console.log('err status' + error.response.status)
//           this.$router.push('/login')
//           break
//         case 404:
//           break
//         case 500:
//           break
//       }
//       return Promise.reject(error)
//     } else {
//       // 处理超时的情况
//       let config = error.config
//       // If config does not exist or the retry option is not set, reject
//       if(!config || !config.retry) return Promise.reject(error)
  
//       // Set the variable for keeping track of the retry count
//       config.__retryCount = config.__retryCount || 0
  
//       // Check if we've maxed out the total number of retries
//       if(config.__retryCount >= config.retry) {
//         // Reject with the error
//         return Promise.reject(error)
//       }
  
//       // Increase the retry count
//       config.__retryCount += 1
  
//       // Create new promise to handle exponential backoff
//       let backoff = new Promise(function(resolve) {
//         setTimeout(function() {
//           resolve()
//         }, config.retryDelay || 1)
//       })
  
//       // Return the promise in which recalls axios to retry the request
//       return backoff.then(function() {
//         return service(config)
//       })
//     }
 
//   }
// )

export default service